// extracted by mini-css-extract-plugin
module.exports = {"fixedAmount":"PaymentBankItemSection__fixedAmount--vJKsz","amount":"PaymentBankItemSection__amount--2NNZL"};